import React from 'react'
import { IBaseDynamicFormElement } from '../Form/DynamicForm'
import SelectItemField from '../../features/items/SelectItemField'

export default function DynamicSelectItemField(props: IBaseDynamicFormElement) {

    const { id, label, fullWidth, data, handleOnChange } = props

    return <SelectItemField selectedItem={data.value} handleChange={(id) => handleOnChange(props.id, id)} />
}